export default {
    loading: false,
    loadingApp: false,
    creating: false,
    deleting: false,
    apps: undefined
}



// WEBPACK FOOTER //
// ./src/redux/reducers/apps/init.js